import { render, staticRenderFns } from "./EditTestkitV2.vue?vue&type=template&id=d0cd1262&scoped=true&"
import script from "./EditTestkitV2.vue?vue&type=script&lang=js&"
export * from "./EditTestkitV2.vue?vue&type=script&lang=js&"
import style0 from "./EditTestkitV2.vue?vue&type=style&index=0&id=d0cd1262&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0cd1262",
  null
  
)

export default component.exports